// components/LoginCardSet.js
import React, { useState } from "react";
import { Box } from "@mui/material";
import { Card, Font, Avatar, Logo } from "pepsico-ds";
import AccessRequestFormModal from "./AccessRequestForm";

import DeniedModal from "./DeniedModal";
export default function LoginCardSet({
  switchToInternal,
  switchToExternal,
  handleOpen,
  open,
  handleClose,
  errors,
  setErrors,
  checkBox,
  setCheckBox,
}) {
  const [openModal, setModalOpen] = useState(false);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Font headingLevel={3} style={{ textAlign: "center" }}>
          Welcome to the PepsiCo’s Agriculture Experience
        </Font>
      </Box>

      {[
        {
          onClick: switchToInternal,
          text: "Sign-in using PepsiCo OKTA credentials",
        },
        {
          onClick: switchToExternal,
          text: "Sign-in using External OKTA credentials",
        },
      ].map(({ onClick, text }, i) => (
        <div
          className="login-card-item"
          style={{ width: "100%" }}
          key={i}
          data-testid="login-cards"
        >
          <Card
            border
            ellipsis={false}
            icon={null}
            title={null}
            primaryButtonProps={{
              size: "large",
              text: "Sign in",
              variant: "primary",
              onClick,
            }}
            style={{ textAlign: "center", justifyContent: "center" }}
          >
            <Logo
              colorStyle="color"
              logoType="pepsicoSymbol"
              style={{ width: 64, height: 64 }}
            />
            <Font headingLevel={6} style={{ textAlign: "center" }}>
              {text}
            </Font>
          </Card>
        </div>
      ))}

      <div className="login-card-item" style={{ width: "100%" }}>
        <Card
          border
          ellipsis={false}
          icon={null}
          title={null}
          primaryButtonProps={{
            size: "large",
            text: "Request access",
            variant: "primary",
            onClick: handleOpen,
          }}
          style={{
            textAlign: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Avatar size="medium" type="icon" />
          <Font headingLevel={6} style={{ textAlign: "center" }}>
            New to the site?
          </Font>
          <Font>Click below to request access to site</Font>
        </Card>
      </div>

      <AccessRequestFormModal
        open={open}
        handleClose={handleClose}
        errors={errors}
        setErrors={setErrors}
        checkBox={checkBox}
        setCheckBox={setCheckBox}
        setModalOpen={setModalOpen}
      />
      <DeniedModal setModalOpen={setModalOpen} openModal={openModal} />
    </>
  );
}
